"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cNewMessageSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
var userCommunications_1 = require("../../userCommunications");
exports.cNewMessageSchema = zod_1.z.strictObject({
    event: zod_1.z.literal(hooks_1.HookName.newMessage),
    action: zod_1.z.literal(hooks_1.HookName.newMessage),
    meta: zod_1.z.optional(zod_1.z.object({
        requester: zod_1.z.number(),
        /** Server file path, for file messages */
        path: zod_1.z.optional(zod_1.z.string())
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    /** ID of block where this user communication was created */
    targetId: zod_1.z.string().uuid(),
    /** ID of user communication just created */
    postId: zod_1.z.optional(zod_1.z.number()),
    senderProfile: zod_1.z.optional(zod_1.z.number()),
    participants: zod_1.z.optional(zod_1.z.array(zod_1.z.number())),
    parentId: zod_1.z.optional(zod_1.z.number()),
    message: zod_1.z.string(),
    scope: zod_1.z.optional(zod_1.z.string()),
    location: zod_1.z.optional(zod_1.z.object({
        moduleSlug: zod_1.z.optional(zod_1.z.string()),
        pageSlug: zod_1.z.optional(zod_1.z.string()),
        name: zod_1.z.optional(zod_1.z.string()),
        page: zod_1.z.optional(zod_1.z.number())
    })),
    /** May be present if this is a chat message within a connection */
    scopeContextData: zod_1.z.optional(zod_1.z.strictObject({
        scopeContextId: zod_1.z.number(),
        scopeContextName: zod_1.z.string()
    }))
}).merge(
// the entire CommunicationMetaData object is spread into the context
userCommunications_1.cCommunicationMetaDataSchema);
